import React from "react";
import { Container, Spinner, Tabs, Tab } from "react-bootstrap";
import { dateDiff } from "../../../_helpers/dateFormatter";
import Header from "../Header";
import "./Notifications.scss";
import useNotifications from "./useNotifications";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { Switch, Space } from "antd";
import MainLayout from "../MainLayout";

export function Notifications(props) {
  const {
    jobChangesNotification,
    loading,
    calendarNotifications,
    onExploreJobsClick,
    onClickNotification,
  } = useNotifications(props);
  const newLocal = "notifications-wrapper";

  return (
    <MainLayout pageName={"Notifications"}>
      <div className={newLocal}>
        <div className="bg-grey-3 p-4 rounded-lg">
          <div className="container d-flex justify-content-between align-items-center">
            <h2 className=""> Notifications</h2>
            <button className="btn btn-primary" onClick={onExploreJobsClick}>
              Explore Jobs
            </button>
          </div>
        </div>
        <Container>
          <div className="inner">
            <div className="row">
              {loading ? (
                <div className="d-flex align-items-center justify-content-center w-100 mt-3">
                  <Spinner
                    animation="border"
                    variant="primary"
                    className="mr-3 mr-lg-4"
                  />
                </div>
              ) : (
                <div className="col-lg-8 col-md-10 fs-smallest text-grey-4">
                  <Tabs defaultActiveKey="Jobs">
                    <Tab eventKey="Jobs" title="Jobs">
                      {/* <div className="d-flex align-items-center justify-content-between pt-2 mt-3 mb-2">
                        <p className="font-weight-medium">LATEST</p>
                        <div className="right d-flex align-items-center">
                          <p className="mr-3 mb-0">Mark all as read</p>
                          <p className="mb-0">Only show unread</p>
                          <Space direction="vertical">
                            <Switch
                              checkedChildren={<CheckOutlined />}
                              unCheckedChildren={<CloseOutlined />}
                              defaultChecked
                              className="ml-3 mb-2"
                            />
                          </Space>
                        </div>
                      </div> */}
                      {jobChangesNotification?.results &&
                      Array.isArray(jobChangesNotification?.results) &&
                      jobChangesNotification.results.length > 0 ? (
                        <ul className="notification-list">
                          {jobChangesNotification?.results &&
                            Array.isArray(jobChangesNotification?.results) &&
                            jobChangesNotification.results.map((item) => (
                              <li
                                className="p-2 mb-2 notification-item rounded-lg cursor-pointer d-flex justify-content-between"
                                onClick={() =>
                                  onClickNotification(
                                    item?.candidate_job_application,
                                    item?.job_posting,
                                    item?.notification_type,
                                    item?.mentor_job_application
                                  )
                                }
                              >
                                <div className=" d-flex">
                                  <div className="icon  mr-3 position-relative">
                                    <img src="./assets/images/dummy.png" />
                                    {item?.read === true && (
                                      <div
                                        className={`status bg-primary rounded-circle mt-2 position-absolute`}
                                      ></div>
                                    )}
                                  </div>
                                  <div className="content">
                                    <p className="font-weight-medium mb-0 text-dark">
                                      {item?.content}
                                    </p>
                                    <span>
                                      {item?.created &&
                                        dateDiff(
                                          item?.created,
                                          new Date()
                                        )}{" "}
                                      ago
                                    </span>{" "}
                                    |{" "}
                                    <span>
                                      Type:{" "}
                                      {item?.notification_type.replace(
                                        /_/g,
                                        " "
                                      )}
                                    </span>
                                  </div>
                                </div>
                              </li>
                            ))}
                        </ul>
                      ) : (
                        <div className="msg-bg text-white p-3 border-6 mt-3 d-flex align-items-center justify-content-center my-2 mw-50 mx-auto">
                          <p className="mb-0">
                            <FontAwesomeIcon
                              icon={faCircleInfo}
                              className="text-white mr-2"
                            />
                            No notifications found.
                          </p>
                        </div>
                      )}
                    </Tab>
                    <Tab eventKey="Calendar" title="Calendar">
                      {/* <div className="d-flex align-items-center justify-content-between pt-2 mt-3">
                        <p className="font-weight-medium">LATEST</p>
                        <div className="right d-flex align-items-center">
                          <p className="mr-3">Mark all as read</p>
                          <p className="">Only show unread</p>
                          <Space direction="vertical">
                            <Switch
                              checkedChildren={<CheckOutlined />}
                              unCheckedChildren={<CloseOutlined />}
                              defaultChecked
                              className="ml-3 mb-2"
                            />
                          </Space>
                        </div>
                      </div> */}
                      {calendarNotifications?.results &&
                      Array.isArray(calendarNotifications?.results) &&
                      calendarNotifications.results.length > 0 ? (
                        <ul className="notification-list">
                          {calendarNotifications?.results &&
                            Array.isArray(calendarNotifications?.results) &&
                            calendarNotifications.results.map((item) => (
                              <li
                                className="p-2 mb-2 notification-item rounded-lg cursor-pointer d-flex justify-content-between"
                                onClick={() =>
                                  onClickNotification(
                                    item?.id,
                                    item?.notification_type,
                                    item?.job_posting
                                  )
                                }
                              >
                                <div className=" d-flex">
                                  <div className="icon  mr-3 position-relative">
                                    <img src="./assets/images/dummy.png" />
                                    {item?.read === true && (
                                      <div
                                        className={`status bg-primary rounded-circle mt-2 position-absolute`}
                                      ></div>
                                    )}
                                  </div>
                                  <div className="content">
                                    <p className="font-weight-medium mb-0 text-dark">
                                      {item?.content}
                                    </p>
                                    <span>
                                      {item?.created &&
                                        dateDiff(
                                          item?.created,
                                          new Date()
                                        )}{" "}
                                      ago{" "}
                                    </span>
                                    |{" "}
                                    <span>
                                      Type:{" "}
                                      {item?.notification_type.replace(
                                        /_/g,
                                        " "
                                      )}
                                    </span>
                                  </div>
                                </div>
                                <div className="status bg-primary rounded-circle mt-2"></div>
                              </li>
                            ))}
                        </ul>
                      ) : (
                        <div className="msg-bg text-white p-3 border-6 mt-3 d-flex align-items-center justify-content-center my-2 mw-50 mx-auto">
                          <p className="mb-0">
                            <FontAwesomeIcon
                              icon={faCircleInfo}
                              className="text-white mr-2"
                            />
                            No calendar notifications found.
                          </p>
                        </div>
                      )}
                    </Tab>
                  </Tabs>
                </div>
              )}
            </div>
          </div>
        </Container>
      </div>
    </MainLayout>
  );
}
export default Notifications;
